import { merge, cloneDeep } from "lodash";
/**
 * Convert a grower inventory item to a coop inventory item
 */
export function createRelisting(listing, overrides, relistingMetaData) {
    const growerListing = cloneDeep(listing);
    merge(growerListing, overrides);
    const newCoopListing = Object.assign(Object.assign({}, growerListing), { backingListing: listing, overrides, seller: overrides.seller, relistingMetaData });
    return newCoopListing;
}
/**
 * given a relisting with a mutated `overrides` field,
 * returns the relisting with the correct merges from the original listing.
 * This matters especially when an override field is _deleted_ such that the original should be used.
 * (Rather than set to the same value)
 *
 * TODO: consider a
 * `(relisting: Immutable<RelistingGeneric<T>>,
 *   overrides: RelistingOverrides<T>)
 *  => RelistingGeneric<T>`
 *
 * structure, vs. this in-place-mutation -> new-object method.
 */
export function updateRelistingFromOverrides(relisting) {
    const growerListing = cloneDeep(relisting.backingListing);
    merge(growerListing, relisting.overrides);
    const newRelisting = Object.assign(Object.assign({}, growerListing), { backingListing: relisting.backingListing, overrides: relisting.overrides, seller: relisting.overrides.seller, relistingMetaData: relisting.relistingMetaData });
    return newRelisting;
}
//# sourceMappingURL=createRelisting.js.map